export default __webpack_public_path__ + "static/media/kadra_janek.2f943191.jpeg";